import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardMedia from '@mui/material/CardMedia';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

import CopyVideoURLButton from './copy-video-url-button';

const StyledItem = styled(Grid)({
    display: 'flex', // Fixed typo: was 'flext'
});

const StyledCard = styled(Card)({
    'display': 'flex',
    'flexDirection': 'column',
    'justifyContent': 'space-between',
    'height': '100%',
    'transition': 'transform .2s',
    '&:hover': {
        transform: 'scale(1.025)',
    },
});

const StyledMedia = styled(CardMedia)({
    '&:hover': {
        cursor: 'pointer',
    },
});

const VideoChooserItem = (props) => {
    const { video, showCopy, onClick } = props;

    const handleVideoClick = useCallback((e) => {
        e.preventDefault();
        onClick(video);
    }, [onClick, video]);

    return (
        <StyledItem
            size={{
                xs: 12,
                sm: 6,
                md: 4,
                lg: 3,
            }}
        >
            <StyledCard>
                <StyledMedia
                    component="video"
                    // height="140"
                    src={video.source}
                    onClick={handleVideoClick}
                />
                {
                    showCopy ?
                        <CardActions>
                            <CopyVideoURLButton video={video} />
                        </CardActions> :
                        null
                }
            </StyledCard>
        </StyledItem>
    );
};

VideoChooserItem.propTypes = {
    video: PropTypes.shape({
        id: PropTypes.number.isRequired,
        source: PropTypes.string.isRequired,
    }).isRequired,
    showCopy: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
};

export default React.memo(VideoChooserItem);
